import { useMemo } from 'react';
import { Breadcrumb } from './Breadcrumbs';
import { useLocation } from 'react-router-dom';

export function useBreadcrumbs(root?: Breadcrumb): Breadcrumb[] {
  const location = useLocation();

  return useMemo(() => {
    const params = new URLSearchParams(location.search);
    const parts = params.get('path')?.split('/').filter(Boolean) ?? [];
    return parts.reduce<Breadcrumb[]>(
      (acc, part, index) => {
        const params = new URLSearchParams(location.search);
        params.set('path', parts.slice(0, index + 1).join('/'));
        return [
          ...acc,
          {
            label: decodeURIComponent(part),
            link: `?${params.toString()}`,
          },
        ];
      },
      root ? [root] : [],
    );
  }, [location.search, root]);
}
